module.exports = __webpack_public_path__ + "assets/img/11_829.1cf9736c.jpg";